import { bbxKind } from '../agents/bbx-kind.js';
import { OcrExtractionType } from '../agents/extraction-modules/ocrExtractionTypes.js';
import { type TaskTypeBehaviour } from './task-main.js';

export const dictationBehaviour = {
  implemented: true,
  structureAgentPrompt: '',
  examCreationPrompt: '',
  boundingBox: {
    [bbxKind.STUDENT_ANSWER]: '',
    [bbxKind.MS]: '',
    [bbxKind.GS]: '',
    [bbxKind.TASKS]: '',
  },
  OCR: {
    [OcrExtractionType.STUDENT_ANSWER]: '',
    [OcrExtractionType.TASK_DESCRIPTION]: '',
    [OcrExtractionType.MASTER_SOLUTION]: `- The master solution only contains the introduction "This is the correct dictation text:" followed by the correct dictation text.
  - The master solution should not contain any other text, formatting`,
    [OcrExtractionType.GRADING_CRITERIA]: '',
  },
  generateMS: `- The master solution only contains the introduction "This is the correct dictation text:" followed by the correct dictation text.
  - The master solution should not contain any other text, formatting, or explanations.
  - The correct dictation text should be exactly as it would be written in the student's answer, including punctuation and capitalization.
  - The master solution should not include any instructions, hints, or additional information.`,
  generateGS: `- Assign one point for each correct word
  - subtract one point for each incorrect word meaning Wrong word, major spelling error, or grammar error that changes the meaning of the word
  - subtract 0.5 points for minor spelling errors or grammar errors that do not change the meaning of the word
  - The total score should be the sum of the points for all words, with a minimum score of 0 and a maximum score equal to the total number of words in the correct dictation text.`,
  grading:
    '- Compare the student answer to the master solution word by word, applying the grading scheme to calculate the total score for the student answer.',
} satisfies TaskTypeBehaviour;
